import { http } from "./http";

export const regionsApi = {
  list: (params) => http.get("/regions", { params }).then((r) => r.data),
  getById: (id) => http.get(`/regions/${id}`).then((r) => r.data),
  create: (payload) => http.post("/regions", payload).then((r) => r.data),
  update: (id, payload) =>
    http.put(`/regions/${id}`, payload).then((r) => r.data),
};
